import {
  Button,
  SingleFieldDialog,
  SingleFieldDialogHeader,
  SingleFieldDialogCTA,
} from "@sellar-io/components";
import { usePriceListVolumeDiscountsDelete } from "../../../hooks/api/v2/priceListVolumeDiscounts/usePriceListVolumeDiscountsDelete";

export const PriceListVolumeDiscountDeleteDialog = ({
  active,
  onDismiss,
  priceListVolumeDiscountsId,
  priceListId,
  volumeDiscountsSetName,
  priceListName,
}: {
  active: boolean;
  onDismiss: () => void;
  priceListVolumeDiscountsId: number;
  priceListId: number;
  volumeDiscountsSetName?: string;
  priceListName?: string;
}) => {
  const deleteMutation = usePriceListVolumeDiscountsDelete(
    priceListId,
    priceListVolumeDiscountsId,
  );

  const handleRemove = () => {
    deleteMutation.mutate(undefined, {
      onSuccess: () => {
        onDismiss();
      },
    });
  };

  const title = volumeDiscountsSetName
    ? `Are you sure you want to remove this '${volumeDiscountsSetName}' volume discount set from this price list?`
    : `Are you sure you want to remove this volume discount set from '${priceListName}' price list?`;

  return (
    <SingleFieldDialog active={active} onDismiss={onDismiss}>
      <SingleFieldDialogHeader
        title={title}
        description="You can add it back on at any time"
        icon="INFORMATION"
        iconClassName="bg-red-50 text-red-600"
      />
      <SingleFieldDialogCTA>
        <Button color="transparent" onClick={onDismiss}>
          Dismiss
        </Button>
        <Button
          color="red"
          onClick={handleRemove}
          loading={deleteMutation.isPending}
        >
          Remove
        </Button>
      </SingleFieldDialogCTA>
    </SingleFieldDialog>
  );
};
